import React, { useEffect, useMemo, useState } from 'react'

import Button from 'components/Form/Button'
import Select from 'components/Form/Select'
import { ListSkeleton } from 'components/Skeleton'

import {
  Actions,
  Card,
  Description,
  EmptyText,
  Eyebrow,
  Title,
} from './styled'

export default function TrainerSelectionCard({
  trainers = [],
  selectedTrainer = '',
  loading,
  error,
  onContinue,
  onSelectionChange,
  onRetry,
}) {
  const [choice, setChoice] = useState(selectedTrainer)
  const options = useMemo(
    () => trainers.map(trainer => ({ id: trainer.documentId, title: trainer.name })),
    [trainers]
  )

  useEffect(() => { setChoice(selectedTrainer) }, [selectedTrainer])

  const selectTrainer = value => {
    setChoice(value)
    onSelectionChange?.(value)
  }

  return (
    <Card>
      <Eyebrow>Certification approval</Eyebrow>
      <Title>Who was your trainer?</Title>
      <Description>Select the trainer who conducted your training before starting the quiz.</Description>
      {loading ? (
        <ListSkeleton rows={2} />
      ) : error ? (
        <>
          <EmptyText>{error}</EmptyText>
          <Button color="blue" nospace width="fit-content" onClick={onRetry}>Try again</Button>
        </>
      ) : !trainers.length ? (
        <EmptyText>No active trainers are available. Contact the training team.</EmptyText>
      ) : (
        <>
          <Select
            id="certificate-trainer"
            placeholder="Select your trainer"
            options={options}
            required
            large
            value={choice}
            onChange={selectTrainer}
          />
          <Actions>
            <Button
              color="blue"
              disabled={!choice}
              nospace
              width="fit-content"
              onClick={() => onContinue(choice)}
            >
              Continue to Quiz
            </Button>
          </Actions>
        </>
      )}
    </Card>
  )
}
